/**
 * `auth` namespace — Korean translations.
 *
 * Mirrors `en/auth.ts` exactly; the `Record<AuthKey, string>` annotation makes a
 * missing or misspelled key a compile error, so this file cannot drift from the
 * canonical English source. SAFETY-RELEVANT copy — the one-time code, the 10-분
 * 만료, and the 소유자 등록(claim) semantics are preserved precisely. Concise
 * 명사형/합니다체.
 */
import type { AuthKey } from "../en/auth";

export const auth: Record<AuthKey, string> = {
  // ── console chrome ──
  tradingConsole: "trading console",

  // ── panel eyebrow + heading (claim vs sign-in are auto-detected) ──
  ownerAccess: "소유자 접근",
  firstRun: "최초 실행",
  signIn: "로그인",
  claimTitle: "이 인스턴스 소유자 등록",
  claimButton: "인스턴스 소유자 등록",
  signInSubtitle: "일회용 코드를 받을 소유자 이메일을 입력하세요.",
  claimSubtitle:
    "아직 소유자가 등록되지 않은 인스턴스입니다. 처음으로 인증을 완료한 이메일이 유일한 소유자가 됩니다.",

  // ── step 1 · request code ──
  emailLabel: "이메일",
  emailPlaceholder: "you@example.com",
  requestCodeError: "코드를 보내지 못했습니다. 주소를 확인하고 다시 시도해 주세요.",
  sendCode: "코드 보내기",

  // ── step 2 · verify code (email rendered inline between prefix + suffix) ──
  codeSentPrefix: "다음 주소로 일회용 코드를 보냈습니다:",
  codeSentSuffix: "해당하는 계정인 경우에만 발송되며, 코드는 10분 후 만료됩니다.",
  verificationCodeLabel: "인증 코드",
  codePlaceholder: "000000",
  verifyError: "코드가 올바르지 않거나 만료되었거나 이미 사용되었습니다.",
  useDifferentEmail: "다른 이메일 사용",

  // ── submit-in-flight + safety hero ──
  working: "처리 중…",
  shipsDisarmed:
    "실거래 비활성 상태로 배포됩니다. 브로커를 연결하고 설정에서 명시적으로 실거래를 활성화하기 전까지는 실제 주문이 발생하지 않습니다.",
};
